import { Typography } from '@mui/material';
import { COLORS } from '../../Styles/Colors';

const minutesSince = (iso: string | null | undefined): number | null => {
  if (!iso) return null;
  const ms = Date.now() - new Date(iso).getTime();
  if (Number.isNaN(ms) || ms < 0) return null;
  return Math.floor(ms / 60000);
};

const formatAge = (mins: number): string => {
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins} min ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 48) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
};

interface FreshnessBadgeProps {
  asOf: string | null | undefined;
  staleAfterMinutes?: number;
  label?: string;
}

/** Spec §41 — show data freshness on every vendor-data screen */
export const FreshnessBadge = ({
  asOf,
  staleAfterMinutes = 36,
  label = 'Data as of',
}: FreshnessBadgeProps) => {
  const age = minutesSince(asOf);
  const stale = age != null && age >= staleAfterMinutes;
  const text = asOf
    ? `${label} ${new Date(asOf).toLocaleString()}${age != null ? ` (${formatAge(age)})` : ''}`
    : `${label} unknown`;

  return (
    <Typography
      variant="caption"
      sx={{
        color: stale ? COLORS.orange || '#c05600' : 'text.secondary',
        fontWeight: stale ? 600 : 400,
      }}
    >
      {stale ? `⚠ ${text}` : text}
    </Typography>
  );
};
